import { formatDDMMYYYY } from "../pages/Documents/forms/Html/LeagleDocuments/forms/commonfunctions";
import BASE from "../config";
import url from "../services/url";
import {
  capitalizeEachWord,
  formatDateDDMMYYYY,
} from "../utils/commonFunctions";

const useConcentPrifilledData = () => {
  const filledConcentData = (
    html,
    application,
    sign,
    aadharDetails,
  ) => {
        if (html.getElementById("signature") !== null) {
          html.getElementById("signature").src = sign
        }
        if (html.getElementById("name_1") !== null) {
          html.getElementById("name_1").innerText = capitalizeEachWord(
            aadharDetails?.aadharVerificationDetails?.data?.full_name
              ? aadharDetails?.aadharVerificationDetails?.data?.full_name
              : application?.name
          );
        }
        if (html.getElementById("date_of_joining") !== null) {
          html.getElementById("date_of_joining").innerText =
            application?.concentDate
              ? formatDateDDMMYYYY(new Date(application?.concentDate))
              : formatDateDDMMYYYY(new Date());
        }
    return html;
  };

  return { filledConcentData };
};

export default useConcentPrifilledData;
